/* eslint-disable @typescript-eslint/await-thenable */
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Head } from 'layouts/Head';
import { auth } from 'lib/firebase/firebase';
import { httpClient } from 'lib/HttpClient';
import { authorize, unauthorize } from 'store/auth/authSlice';
import { AppWrapper } from './app/AppWrapper';
import { initStore } from './store/store';
import { Root } from './pages';
import { LicenseInfo } from '@mui/x-license';
import { checkAndUpdateGlobalStorageVersion } from 'lib/MuiGrid/StateController';
import { addTabMerchantChangeListener, removeTabMerchantChangeListener } from 'app/multi-tab-bus';
import { onAuthStateChanged } from 'firebase/auth';
import { Userpilot } from 'userpilot';

LicenseInfo.setLicenseKey(import.meta.env.MATERIAL_UI_KEY);
if (import.meta.env.NODE_ENV === 'production') {
    Userpilot.initialize(import.meta.env.USERPILOT_KEY);
}

const store = initStore();

export function App() {
    const [isFirebaseLoaded, setIsFirebaseLoaded] = React.useState(false);

    React.useEffect(() => {
        checkAndUpdateGlobalStorageVersion();
        const authUnsubscribe = onAuthStateChanged(auth(), async user => {
            if (user) {
                if (window.dataLayer) {
                    window.dataLayer.push({ firebaseUserId: user.uid });
                }
                httpClient.refreshToken = () => {
                    store.dispatch(authorize());
                };
                await store.dispatch(authorize());
                addTabMerchantChangeListener();
            } else {
                httpClient.updateToken('');
                await store.dispatch(unauthorize());
            }
            setIsFirebaseLoaded(true);
        });
        return () => {
            removeTabMerchantChangeListener();
            authUnsubscribe();
        };
    }, []);

    return (
        <Provider store={store}>
            <BrowserRouter>
                <AppWrapper>
                    <Head />
                    <Root isFirebaseLoaded={isFirebaseLoaded} />
                </AppWrapper>
            </BrowserRouter>
        </Provider>
    );
}
